import { Component, OnInit } from '@angular/core';
import { ProgressService } from '../../services/progress.service';

@Component({
    selector: 'mih-loader',
    templateUrl: './progress.component.html',
    providers:[]
})
export class ProgressComponent implements OnInit {
    loading: boolean = false;
    constructor(private progressService: ProgressService) { }

    ngOnInit() {
        this.progressService.getInProgress()
            .subscribe((count) => {
                this.loading = count > 0;
        });
    }

}
